import React, { useEffect, useRef, useState } from "react";
import "./AnimatedTabbar.css";
import { useLayoutShift } from "../../hooks/useLayoutShift";

export function AnimatedTabbarItem({ children, name, value, ...props }) {
   return (
      <li className={`animated-tabbar-wrapper`} data-active={value === name} data-name={name} {...props}>
         <button type="button" className="animated-tabbar-item">
            {children}
         </button>
      </li>
   );
}

export function AnimatedTabbar({ value = null, children, onChange, className, classNameList, ...props }) {
   const [tab, setTab] = useState(value || null);
   const { ref, state } = useLayoutShift();
   const tabsContainerRef = useRef();

   useEffect(() => {
      if (value === tab) return;
      setTab(value);
   }, [value]);

   function renderChildren() {
      return children.map((child, i) => {
         return React.cloneElement(child, {
            value: tab,
            key: i,
            onClick: () => {
               setTab(child.props.name);
               if (onChange) onChange(child.props.name);
            },
         });
      });
   }

   function updateSelectionLine() {
      let element = tabsContainerRef.current?.querySelector(`.animated-tabbar-wrapper[data-name="${tab}"]`);
      if (element) {
         const containerRect = tabsContainerRef.current.getBoundingClientRect();
         const rect = element.getBoundingClientRect();
         const newSelectionLineWidth = rect.width;
         const newSelectionLineLeft = rect.left - containerRect.left;
         tabsContainerRef.current.style.setProperty('--selectionLineWidth', newSelectionLineWidth + 'px');
         tabsContainerRef.current.style.setProperty('--selectionLineLeft', newSelectionLineLeft + 'px');
      }
   }

   useEffect(() => {
      if (!tabsContainerRef.current) return;
      updateSelectionLine();
      const tabsElements = tabsContainerRef.current.querySelectorAll('li.animated-tabbar-wrapper');
      const resizeObserver = new ResizeObserver(updateSelectionLine);
      tabsElements.forEach(element => {
         resizeObserver.observe(element);
      });
      return () => resizeObserver.disconnect();
   }, [tab, tabsContainerRef]);

   useEffect(() => {
      if (state.shifted || state.overflowX) {
         updateSelectionLine();
      }
   }, [state]);

   return (
      <div ref={ref} className={`animated-tabbar ${className}`} {...props}>
         <ul ref={tabsContainerRef} className={`animated-tabbar-list ${classNameList}`}>
            {renderChildren()}
         </ul>
      </div>
   );
}